import React from 'react';
import Icon from '../../../components/AppIcon';

const QuizLoadingState = ({ message = "Loading quiz questions..." }) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center space-y-6">
        {/* Loading Animation */}
        <div className="relative">
          <div className="flex items-center justify-center w-20 h-20 bg-accent-50 rounded-full mx-auto">
            <Icon name="Brain" size={32} color="var(--color-accent)" strokeWidth={2} />
          </div>
          <div className="absolute inset-0 w-20 h-20 border-4 border-accent-200 border-t-accent rounded-full animate-spin mx-auto" />
        </div>

        {/* Loading Text */}
        <div className="space-y-2">
          <h2 className="text-xl font-heading font-semibold text-text-primary">
            Preparing Your Assessment
          </h2>
          <p className="text-text-secondary max-w-sm mx-auto">
            {message}
          </p>
        </div>

        {/* Loading Progress Dots */}
        <div className="flex items-center justify-center space-x-2">
          <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
          <div className="w-2 h-2 bg-accent rounded-full animate-pulse" style={{ animationDelay: '0.2s' }} />
          <div className="w-2 h-2 bg-accent rounded-full animate-pulse" style={{ animationDelay: '0.4s' }} />
        </div>
      </div>
    </div>
  );
};

export default QuizLoadingState;